import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

export default {
  state: {
    pageSize: 10,
    pageNumber: 1, // Index; Starts at 1
    hasMorePages: false,
    orderHistory: {},
    orders: {},
    isFetchingOrderHistory: false
  },
  getters: {
    getOrderHistory(state) {
      return Object.values(state.orderHistory)
    },
    getOrder: (state) => (id) => state.orders[ id ] || {},
    getHasMoreOrderHistoryPages(state) {
      return state.hasMorePages
    },
    getIsFetchingOrderHistory(state){
      return state.isFetchingOrderHistory
    }
  },
  actions: {
    fetchOrderHistoryPage({ state, dispatch, rootState, commit }) {
      let config = { headers: { Authorization: rootState.auth.user.authToken } }

      commit('SET_IS_FETCHING_ORDER_HISTORY', true)

      const onSuccess = res => {
        const { currentPage: data, pageNumber, totalSize } = res.data
        const pageInfo = {
          pageNumber,
          totalSize
        }

        commit('ADD_ORDER_HISTORY_ITEMS', data)

        commit('SET_PAGE_INFO', pageInfo)
      }

      const onError = e => {
        const text = get(e, 'response.data.errorMsg', '')
        const payload = { text, color: 'error' }
        dispatch('showSnack', payload)
      }

      return this.$api.get(`/order/history?size=${state.pageSize}&page=${state.pageNumber}`, config)
        .then(onSuccess)
        .catch(onError)
        .finally(() => { commit('SET_IS_FETCHING_ORDER_HISTORY', false)})
    },

    ensureOrder({ commit, dispatch, getters, rootState }, { orderId, storeId }) {
      const order = getters.getOrder(orderId)

      let config = {
        headers: {
          Authorization: rootState.auth.user.authToken,
          storeId
        }
      }

      const onError = e => {
        const text = get(e, 'response.data.errorMsg', '')
        const payload = { text, color: 'error' }
        dispatch('showSnack', payload)
      }

      if (isEmpty(order)) {
        this.$api.get(`/order/${orderId}`, config)
          .then(res => {
            commit('ADD_ORDER', res.data)
          })
          .catch(onError)
      }
    }
  },
  mutations: {
    SET_IS_FETCHING_ORDER_HISTORY(state, val) {
      state.isFetchingOrderHistory = !!val
    },
    RESET_ORDER_HISTORY_PAGE(state) {
      state.pageNumber = 1
      state.hasMorePages = false
      state.orderHistory = {}
    },
    SET_PAGE_INFO(state, pageInfo) {
      const { pageNumber, totalSize } = pageInfo

      state.hasMorePages = totalSize !== Object.values(state.orderHistory).length

      if (state.hasMorePages) {
        state.pageNumber = pageNumber + 1
      }
    },
    ADD_ORDER_HISTORY_ITEMS(state, orderHistoryItems) {
      const orderMap = orderHistoryItems.reduce((prev, current) => {
        prev[ current.orderId ] = current

        return prev
      }, {})

      state.orderHistory = {
        ...state.orderHistory,
        ...orderMap
      }
    },
    ADD_ORDER(state, order) {
      const { orderId } = order

      if (orderId) {
        let newState = { ...state.orders }
        newState[ orderId ] = order
        state.orders = newState
      }
    }
  }
}
